import React from "react";

import {bindActionCreators} from "redux";
import {withRouter, NavLink } from "react-router-dom";
import {connect} from "react-redux";
import CloudFlyerAPI from "../../api/CloudFlyerAPI";
import {receiveError} from "../../api/http";
import arrowLeft from "../../assets/img/icon/arrow-left-icon.svg";
import {Modal, Button, message, Table, Tooltip, Input, Space, Checkbox} from "antd";


import "./productPackagesDashboard.scss";
import {DeleteFilled, SendOutlined} from "@ant-design/icons";

class ProductPackagesDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            packages: [],
            modalData: {},
            pageSize: 50,
            page: 1,
            total: 0,
            deleted: false,
            visible: false
        };
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    componentDidMount() {
        this.setState({
            loading: true,
        });
        this.fetchAllUsers();
    }

    fetchAllUsers() {
        CloudFlyerAPI.product_packages
            .getAllPackages(this.state.pageSize, this.state.page, this.state.deleted)
            .then(({data}) => {
                console.log(data)
                this.setState({
                    loading: false,
                    packages: data.data,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    onPageChange = page => {
        this.setState({page: page, loading: true})


        this.fetchAllUsers();
    }

    handleDeleteClick(id) {
        CloudFlyerAPI.product_packages
            .deletePackage(id)
            .then(({data}) => {
                console.log(data)
                this.setState({
                    loading: true,
                });
                this.fetchAllUsers();
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    render() {
        const {history} = this.props;
        const showDeleteConfirm = (
            e,
            handleDeleteClick,
            id) => {
            e.stopPropagation()
            Modal.confirm({
                title: `Are you sure you want to Delete this Package?`,
                content:
                    "",
                onOk() {
                    handleDeleteClick(id)
                }
            })
        }
        const showDetail = (
            e, data) => {
            e.stopPropagation()
            console.log("Data received:", data);
            Modal.confirm({
                title: `Detail`,
                content: (
                    <>
                        <p><strong>Name:</strong> {data.name}</p>
                        <p><strong>Description:</strong> {data.description}</p>
                        <p><strong>Price:</strong> {data.price}</p>
                        <p><strong>Price ID:</strong> {data.priceId}</p>
                        <p><strong>Duration:</strong> {data.duration}</p>
                        <p><strong>Max Admin Users:</strong> {data.maxAdminUsers}</p>
                        <p><strong>Max Creative Users:</strong> {data.maxCreativeUsers}</p>
                        <p><strong>Max Standard Users:</strong> {data.maxStandardUsers}</p>
                        <p><strong>Max Storage:</strong> {data.maxStorage}</p>
                        <p><strong>Max Connections:</strong> {data.maxConnections}</p>
                        <p><strong>Max Projects:</strong> {data.maxProjects}</p>
                        <p><strong>Max Teams:</strong> {data.maxTeams}</p>
                        <p><strong>Max Drives:</strong> {data.maxDrives}</p>
                        <p><strong>Max Syncs:</strong> {data.maxSyncs}</p>
                        <p><strong>SSO:</strong> {data.sso ? "True" : "False"}</p>
                        <p><strong>Logs:</strong> {data.logs ? "True" : "False"}</p>
                    </>
                ),
                onOk() {
                    // handleDeleteClick(id)
                }
            })
        }

        const columns = [
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
                ellipsis: {
                    showTitle: false,
                },
                render: (username) => (
                    <Tooltip placement="topLeft" title={username}>
                        {username}
                    </Tooltip>
                ),
                width: 100,
            },
            {
                title: "Description",
                dataIndex: "description",
                key: "description",
                width: 130,
            },
            {
                title: "Price",
                dataIndex: "price",
                key: "price",
                ellipsis: {
                    showTitle: false,
                },
                render: (accountName) => (
                    <Tooltip placement="topLeft" title={accountName}>
                        {accountName}
                    </Tooltip>
                ),
                width: 70,
            },
            {
                title: "Price Id",
                dataIndex: "priceId",
                key: "priceId",
                width: 90,
            },
            {
                title: "Duration",
                dataIndex: "duration",
                key: "duration",
                width: 90,
            },
            {
                title: "SSO",
                dataIndex: "sso",
                key: "sso",
                width: 70,
                render: (value) => (value ? "True" : "False"),
            },
            {
                title: "Logs",
                dataIndex: "logs",
                key: "logs",
                width: 70,
                render: (value) => (value ? "True" : "False"),
            },
            {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
                width: 100,
                ellipsis: {
                    showTitle: false,
                },
                render: action => (
                    <div className="userActions">
                        <Tooltip placement="topLeft" title={
                            action.duration
                        }>
                            <Button
                                className="replication-delete-btn"
                                icon="exception" onClick={e =>{
                                    this.state.modalData =  action.postData.data;
                                this.showModal()
                            }
                            }
                            />
                        </Tooltip>
                        <Tooltip placement="topLeft" title="Delete User">
                            <DeleteFilled
                                className={`${this.state.deleted ? 'hidden' : ''} ${action.status}`} onClick={e =>
                                showDeleteConfirm(e, this.handleDeleteClick, action.id,)
                            }/>
                        </Tooltip>
                    </div>
                ),
            }
        ];

        let data = this.state?.packages?.map((t, index) => {
            return {
                key: t.id,
                id: t.id,
                name: t.name,
                description: t.description,
                price: t.price,
                priceId: t.priceId,
                duration: t.duration === 1 ? "Monthly" : "Annual",
                maxAdminUsers: t.maxAdminUsers,
                maxCreativeUsers: t.maxCreativeUsers,
                maxStandardUsers: t.maxStandardUsers,
                maxStorage: t.maxStorage,
                maxConnections: t.maxConnections,
                maxProjects: t.maxProjects,
                maxTeams: t.maxTeams,
                maxDrives: t.maxDrives,
                maxSyncs: t.maxSyncs,
                sso: t.sso,
                logs: t.logs,
                action: {
                    id: t.id,
                    postData: {
                        data: t,
                        id: t.id,
                        username: t.username,
                        email: t.username,
                        firstname: t.firstname,
                        lastname: t.lastname,
                    },
                    detailData: {id: t.id, name: t.accountName, accountId: t.accountId}
                }
            };
        });

        const packageColumns = [
            {
                title: '',
                dataIndex: 'attribute',
                key: 'attribute',
            },
            {
                title: '',
                dataIndex: 'value',
                key: 'value',
                align: 'center',
            },
        ];

        const packageData = [
            { key: '1', attribute: 'Name', value: this.state.modalData.name },
            { key: '2', attribute: 'Description', value: this.state.modalData.description },
            { key: '3', attribute: 'Price', value: this.state.modalData.price },
            { key: '4', attribute: 'Price ID', value: this.state.modalData.priceId },
            { key: '5', attribute: 'Duration', value: this.state.modalData.duration === 1 ? "Monthly" : "Annual" },
            { key: '6', attribute: 'Max Admin Users', value: this.state.modalData.maxAdminUsers },
            { key: '7', attribute: 'Max Creative Users', value: this.state.modalData.maxCreativeUsers },
            { key: '8', attribute: 'Max Standard Users', value: this.state.modalData.maxStandardUsers },
            { key: '9', attribute: 'Max Storage', value: this.state.modalData.maxStorage },
            { key: '10', attribute: 'Max Connections', value: this.state.modalData.maxConnections },
            { key: '11', attribute: 'Max Projects', value: this.state.modalData.maxProjects },
            { key: '12', attribute: 'Max Teams', value: this.state.modalData.maxTeams },
            { key: '13', attribute: 'Max Drives', value: this.state.modalData.maxDrives },
            { key: '14', attribute: 'Max Syncs', value: this.state.modalData.maxSyncs },
            { key: '15', attribute: 'SSO', value: this.state.modalData.sso ? 'True' : 'False' },
            { key: '16', attribute: 'Logs', value: this.state.modalData.logs ? 'True' : 'False' },
        ];

        return (
            <div className="usersListdashboard">
                <div className="header">
                    <div className="left-wrapper">
                        <h2 className="title-back"><NavLink to="/"><img src={arrowLeft} alt="icon"/></NavLink>Packages</h2>
                    </div>
                    <div className="right-wrapper">
                        <div className="text-left">

                            <Checkbox onChange={(e) => {
                                console.log(e.target.checked)
                                this.state.deleted = e.target.checked;

                                this.setState({
                                    loading: true,
                                });
                                this.fetchAllUsers();
                            }} defaultChecked={false}>Deleted</Checkbox>

                        </div>

                        <Button
                            className="add-user-btn"
                            type="primary"
                            onClick={() => history.push("/addNewPackage")}>
                            Add New Package
                        </Button>
                    </div>
                </div>
                <div className="active-jobs-wrapper-list">
                    <Table
                        loading={this.state.loading}
                        columns={columns}
                        dataSource={data}
                        pagination={{
                            onChange: this.onPageChange,
                            total: this.state.total,
                            current: this.state.page,
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} items`,
                            pageSize: this.state.pageSize,
                        }}
                        scroll={{y: 600}}
                    />

                </div>

                <Modal
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button onClick={this.handleCancel}>
                            Cancel
                        </Button>,
                        <Button type="primary" onClick={()=>{


                            const queryString = encodeURIComponent(JSON.stringify(this.state.modalData));

                            this.props.history.push("/editPackage/?data=" + queryString );
                        }}>
                            Edit
                        </Button>,
                    ]}
                    className={"detail-modal"}
                >
                    <h3 className="text-center">Package Detail</h3>
                    <Table columns={packageColumns} dataSource={packageData} pagination={false} bordered  size="small" showHeader={false}/>
                </Modal>
            </div>
        );
    }
}

export default withRouter(
    connect(
        ({auth, cloudAccounts}, {match, history}) => {
            let user = auth.user;
            return {
                ...user,
                cloudAccounts,
            };
        },
        (dispatch) => bindActionCreators({}, dispatch)
    )(ProductPackagesDashboard)
);
